import instance from '../instance';

const getClosestReferenceId = (liveNode) =>
  instance.driver.referenceMap.getClosestReferenceId(liveNode);

export default getClosestReferenceId;
